{
  "overview.title": "Oversikt",
  "overview.body": "Slik ser dagen ut på {workshop}.",
  "overview.kpi.today": "Jobber i dag",
  "overview.kpi.today_hint": "Fra midnatt til midnatt, avbestilte holdt utenfor.",
  "overview.kpi.week": "Neste sju dager",
  "overview.kpi.week_hint": "Alt som er booket framover.",
  "overview.kpi.pending": "Venter på svar",
  "overview.kpi.pending_hint": "Bestillinger du må ta stilling til.",
  "overview.kpi.value": "Verdi i dag",
  "overview.kpi.value_hint": "Sum for dagens jobber.",
  "overview.today.heading": "Dagens jobber",
  "overview.today.empty": "Ingen bestillinger i dag.",
  "overview.column.time": "Tid",
  "overview.column.customer": "Kunde",
  "overview.column.service": "Tjeneste",
  "overview.column.resource": "Ressurs",
  "overview.column.status": "Status",
  "overview.column.value": "Verdi",
  "overview.unassigned": "Ingen tildelt",
  "overview.open_calendar": "Åpne kalenderen",
  "overview.error": "Vi klarte ikke å hente oversikten.",
  "calendar.title": "Kalender",
  "calendar.today": "I dag",
  "calendar.previous": "Forrige",
  "calendar.next": "Neste",
  "calendar.view.day": "Dag",
  "calendar.view.week": "Uke",
  "calendar.view.month": "Måned",
  "calendar.new_booking": "Ny bestilling",
  "calendar.create.walkin": "Drop-in",
  "calendar.create.walkin.hint": "Kunden står i verkstedet. Bestillingen bekreftes med en gang.",
  "calendar.create.service": "Tjeneste",
  "calendar.create.service.empty": "Ingen tjenester er lagt inn ennå.",
  "calendar.create.when": "Tid",
  "calendar.create.date": "Dato",
  "calendar.create.resource": "Utføres av",
  "calendar.create.resource.auto": "Velg for meg",
  "calendar.create.customer": "Kunde",
  "calendar.create.name": "Navn",
  "calendar.create.email": "E-post",
  "calendar.create.email.hint": "Bekreftelsen sendes hit. Uten e-post trengs et telefonnummer.",
  "calendar.create.phone": "Telefon",
  "calendar.create.submit": "Opprett bestilling",
  "calendar.create.saving": "Oppretter …",
  "calendar.create.created": "Bestillingen er opprettet.",
  "calendar.create.error.service": "Velg minst én tjeneste.",
  "calendar.create.error.name": "Skriv kundens navn.",
  "calendar.create.error.email": "Kontroller e-postadressen.",
  "calendar.create.error.contact": "Vi trenger enten en e-postadresse eller et telefonnummer.",
  "calendar.create.slots": "Ledige tider",
  "calendar.create.slots.hint": "Velg en tjeneste for å se ledige tider.",
  "calendar.create.slots.empty": "Ingen ledige tider denne dagen.",
  "calendar.create.slots.nearest": "Nærmeste ledige tider",
  "calendar.create.slots.taken": "Den tiden er opptatt. Velg en av tidene nedenfor.",
  "calendar.create.slots.none": "Fullbooket {days} dager fremover.",
  "calendar.create.slots.error": "Kunne ikke hente ledige tider.",
  "calendar.create.slots.pick": "Velg {time}",
  "calendar.create_in_column": "Ny bestilling for {resource}",
  "calendar.filter": "Filter",
  "calendar.filter.clear": "Nullstill filter",
  "calendar.filter.resource": "Ressurs",
  "calendar.filter.service": "Tjeneste",
  "calendar.filter.status": "Status",
  "calendar.filter.all": "Alle",
  "calendar.zoom": "Radhøyde",
  "calendar.now": "Nå",
  "calendar.week_of": "Uke {week}",
  "calendar.status.pending": "Ikke bekreftet",
  "calendar.status.confirmed": "Bekreftet",
  "calendar.status.in_progress": "Pågår",
  "calendar.status.completed": "Ferdig",
  "calendar.status.cancelled": "Avbestilt",
  "calendar.status.no_show": "Møtte ikke",
  "calendar.status.external": "Fra Google",
  "calendar.resource.staff": "Tekniker",
  "calendar.resource.van": "Mobil enhet",
  "calendar.resource.bay": "Plass",
  "calendar.blocker.vacation": "Ferie",
  "calendar.blocker.sick": "Syk",
  "calendar.blocker.training": "Opplæring",
  "calendar.blocker.break": "Pause",
  "calendar.blocker.closed": "Stengt",
  "calendar.blocker.blackout": "Sperret",
  "calendar.blocker.add": "Blokker tid",
  "calendar.blocker.kind": "Årsak",
  "calendar.blocker.whole_day": "Hele dagen",
  "calendar.blocker.repeat": "Gjenta hver uke",
  "calendar.blocker.repeat_until": "Til og med",
  "calendar.blocker.save": "Lagre blokkering",
  "calendar.blocker.remove": "Fjern blokkering",
  "calendar.blocker.synced": "Kommer fra Google og kan ikke endres her.",
  "calendar.event.label": "{service}, {time}, {resource}, {status}",
  "calendar.event.buffer": "Forberedelsestid",
  "calendar.drag.moved": "Flyttet til {time}, {resource}",
  "calendar.drag.saved": "Lagret: {time}, {resource}",
  "calendar.drag.cancelled": "Flyttingen ble avbrutt",
  "calendar.drag.hint": "Mellomrom for å flytte, piltaster for å velge tid, Enter for å lagre.",
  "calendar.empty.day": "Ingen bestillinger i dag. Vil du legge til en?",
  "calendar.empty.filtered": "Ingen bestillinger passer filteret.",
  "calendar.empty.no_resources": "Dette verkstedet har ingen ressurser ennå.",
  "calendar.error.load": "Vi klarte ikke å hente kalenderen.",
  "calendar.error.retry": "Prøv igjen",
  "calendar.offline": "Du er frakoblet. Kalenderen vises slik den så ut sist.",
  "calendar.stale.one": "{count} ny bestilling — oppdater",
  "calendar.stale.other": "{count} nye bestillinger — oppdater",
  "calendar.conflict.title": "Tiden er dessverre allerede booket",
  "calendar.conflict.alternatives": "Her er tre andre tider:",
  "calendar.conflict.reverted": "Bestillingen ligger fortsatt på den gamle tiden.",
  "calendar.unassigned.title": "Uten ressurs",
  "calendar.unassigned.empty": "Alle bestillinger er tildelt.",
  "calendar.unassigned.hint": "Dra en bestilling til en kolonne for å tildele den.",
  "calendar.unassigned.assign": "Tildel {resource}",
  "route.title": "Dagens rute",
  "route.empty": "Ingen stopp i dag.",
  "route.stop": "Stopp {index}",
  "route.travel_from_previous": "{minutes} min kjøring ({km} km)",
  "route.travel_from_base": "{minutes} min fra verkstedet ({km} km)",
  "route.no_address": "Ingen adresse oppgitt",
  "route.estimate_note": "Kjøretidene er anslag i luftlinje.",
  "job.title": "Jobbkort",
  "job.customer": "Kunde",
  "job.object": "Objekt",
  "job.services": "Tjenester",
  "job.status": "Status",
  "job.notes": "Interne notater",
  "job.notes.placeholder": "Vises bare for dere på verkstedet.",
  "job.notes.save": "Lagre notat",
  "job.notes.saved": "Notatet er lagret",
  "job.photos": "Bilder",
  "job.photos.before": "Før",
  "job.photos.after": "Etter",
  "job.photos.damage": "Skade",
  "job.photos.add": "Legg til bilde",
  "job.photos.empty": "Ingen bilder ennå.",
  "job.photos.uploading": "Laster opp …",
  "job.photos.remove": "Fjern bilde",
  "job.photos.too_large": "Bildet er for stort. Maks {mb} MB.",
  "job.photos.wrong_type": "Dette ser ikke ut som et bilde.",
  "job.notifications": "Utsendelser",
  "job.notifications.empty": "Ingen utsendelser for denne bestillingen.",
  "job.total": "Totalt",
  "job.booked_at": "Bestilt {when}",
  "job.source.web": "Bestilt på nettet",
  "job.source.phone": "Bestilt per telefon",
  "job.source.walkin": "Drop-in",
  "job.source.partner": "Bestilt av partner",
  "job.source.import": "Importert bestilling",
  "job.cancel": "Avbestill",
  "job.cancel.reason": "Årsak",
  "job.cancel.confirm": "Avbestill bestillingen",
  "job.cancel.warning": "Kunden får en e-post om at tiden er avbestilt.",
  "calendar.create.drop_off": "Levering",
  "calendar.create.ready": "Ferdig",
  "calendar.create.ready_invalid": "Ferdig må være minst 5 minutter etter levering.",
  "job.times": "Tid og pris",
  "job.times.save": "Lagre",
  "job.times.saved": "Lagret",
  "job.price": "Pris ({currency})"
}
